import React from "react";
import { useDownloadAdditionalTaxes } from "./hooks/useDownloadAdditionalTaxes";
import { uiNotification } from "../../../../services/UINotificationService";
import styles from "./scss/DownloadTaxesButton.module.scss";

const DownloadTaxesButton = ({ clinicId, invoiceId }) => {
  const { mutate, isLoading } = useDownloadAdditionalTaxes();

  const handleDownload = () => {
    mutate(
      { clinicId, invoiceId },
      {
        onSuccess: (res) => {
          if (res.data.data.file) {
            window.open(res.data.data.file, "_blank");
          }
        },
        onError: (error) =>
          uiNotification.error(
            error?.response?.data?.message ||
              "An error occurred while downloading the additional taxes details.",
          ),
      },
    );
  };
  return (
    <button
      onClick={handleDownload}
      disabled={isLoading}
      className={styles.downloadButton}
    >
      Preview Taxes
    </button>
  );
};

export default DownloadTaxesButton;
